import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item" }

import CheaterIp from "@/projects/tenant/modules/tools/modals/CheaterIp.vue";
import BlockedList from "@/projects/tenant/modules/tools/modals/BlockedList.vue";
import ViolationList from "@/projects/tenant/modules/tools/modals/ViolationList.vue";
import { ref, provide } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SpecialListIndex',
  setup(__props) {

const tab = ref("cheaterIp");
const isLoading = ref(false);
provide("isLoading", isLoading);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-4", [
            { active: tab.value === 'cheaterIp' },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (tab.value = 'cheaterIp'))
        }, _toDisplayString(_ctx.$t("title.cheaterIp")), 3)
      ]),
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-4", [
            { active: tab.value === 'blockedList' },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 'blockedList'))
        }, _toDisplayString(_ctx.$t("title.blockedList")), 3)
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-4", [
            { active: tab.value === 'violationList' },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          active: "",
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (tab.value = 'violationList'))
        }, _toDisplayString(_ctx.$t("title.violationList")), 3)
      ])
    ]),
    (tab.value === 'cheaterIp')
      ? (_openBlock(), _createBlock(CheaterIp, { key: 0 }))
      : _createCommentVNode("", true),
    (tab.value === 'blockedList')
      ? (_openBlock(), _createBlock(BlockedList, { key: 1 }))
      : _createCommentVNode("", true),
    (tab.value === 'violationList')
      ? (_openBlock(), _createBlock(ViolationList, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})